"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
var react_1 = __importDefault(require("react"));
var DropDownItem_scss_1 = __importDefault(require("./DropDownItem.scss"));
var classnames_1 = __importDefault(require("classnames"));
var DropdownItem = function (props) {
    return (react_1.default.createElement("button", { className: (0, classnames_1.default)("dropdown-item", DropDownItem_scss_1.default['au-dropdownitem']), onClick: function (e) {
            e.preventDefault();
            props.onClick();
        } }, props.label));
};
exports.DropdownItem = DropdownItem;
//# sourceMappingURL=DropdownItem.js.map